<style src="css/article.css" scoped></style>
<template>
    <div style="padding-top: 1rem">
        <div class="fixedBox">
            <div class="topBox">
                <div class="backIcon" @click="back"></div>
                <div class="topTitle">创作中心</div>
                <div></div>
<!--                <div class="rule" @click="to(`editPrice`)">草稿箱</div>-->
            </div>
        </div>
        <div class="topBtnBox">
            <div class="btnIconBox" @click="to(`create`)">
                <div class="write"></div>
                写文章
            </div>
            <div class="btnIconBox">
                <div class="notice" @click="to('rules')"></div>
                规则
            </div>
        </div>
        <!--<div class="statusBox">-->
        <!--<div :class="{ actived:qStatus==0}" class="no" @click="change(0)">-->
        <!--未核销-->
        <!--</div>-->
        <!--<div class="line"></div>-->
        <!--<div class="yes" :class="{ actived:qStatus==1}" @click="change(1)">-->
        <!--已核销-->
        <!--</div>-->
        <!--</div>-->
        <ul>
            <li v-for="item in homePageTopicList" @click="toWhere(item.auditStatus,item.articleId)">
                <div class="itemTopBox">
                    时间：{{item.createTime | time}} <span @click.stop="showMask(item.auditStatus,item.articleId)"></span>
                </div>
                <div class="itemContentBox">
                    <div class="mainLeft">
                        <div class="leftBox">
                            <div class="mainTitle">{{item.title}}</div>
                            <div class="mainStatus" v-if="item.auditStatus!==1">{{item.auditStatus | isAuditStatus}} <span v-if="item.auditStatus===2" @click.stop="item.remarkStatus=!item.remarkStatus"></span></div>
                            <div class="successBox" v-if="item.auditStatus===1">{{item.readCount}}阅读 <span>{{item.loveCount}}点赞</span></div>
                        </div>
                        <div class="remark" v-if="item.remarkStatus">{{item.remark}}</div>

                    </div>
                    <div class="mainRight">
                        <img :src="EnvUrl+item.pic" alt="">
                    </div>
                </div>
            </li>
        </ul>

        <no-more-data :noMoreData="noMoreData"></no-more-data>

        <div class="maskBox" v-if="mask">
            <div class="maskBtn" :class="{active:maskBtnStatus}" @click="edit()">编辑</div>
            <div class="maskBtn" @click="modifyArticle">删除</div>
            <div class="maskBtn" @click="cancle">取消</div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources,getSourcesJson} from "../api"
    import Vue from 'vue'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import noMoreData from 'components/no-more-data'
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
                mask:false,
                maskBtnStatus:false,
                homePageTopicList: [],
                mid: this.$route.query.mid ? this.$route.query.mid : "",
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex: 1,
                isLoading: false,
                noMoreData: false,
                count: 0,
                qStatus: 0,
                mask1:false,
                mask2:false,
                refundReason:'',
                id:'',
                userId:'',
                doctorId:'',
                articleId:'',
            }
        },
        components: {
            topbar,
            noMoreData,
        },
        computed: {},
        filters: {
            time(value){
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isOrderType(value){
                return ['付费咨询单','打赏单','用户退款'][value]
            },
            isAuditStatus(tag) {
                if(tag===-1){
                    return '草稿'
                }else if(tag===0){
                    return '待审核'
                }else if(tag===1){
                    return '审核通过'
                }else if(tag===2){
                    return '不通过'
                }
                // let arr = ['待审核', '审核通过','不通过']
                // return arr[tag]
            },

        },
        methods: {
            toWhere(n,id){
                if(n===-1 || n===0 || n===2){
                    this.to(`create?articleId=${id}`)
                }else if(n===1){
                    window.location.href = `https://m.120xinmao.cn/testScale/articleDetail?articleId=${id}`
                }
            },
            edit(){
                if(!this.maskBtnStatus){
                    this.to(`create?articleId=${this.articleId}`)
                }else{

                }

            },
            showMask(n,id){
                if(n===1||n===2){
                    this.maskBtnStatus=true
                }
                this.mask=true;
                this.articleId=id;
            },
            cancle(){
                this.mask=false;
                this.maskBtnStatus=false;
                this.articleId='';
            },
            back(){
                this.$router.push(`/`)
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },
            serialize(obj) {

                let str = ""
                for (let key in obj) {
                    str += `${key}=${obj[key]}&`
                }
                str = str.slice(0, -1)
                return str

            },
            run(id){
                if(this.qStatus){
                    this.mask2=true;
                    this.id=id
                }else{
                    this.medorderwriteoff(id)
                }

            },
            sureThis(){
                let paramsObj = {}
                paramsObj.orderId = this.id;
                paramsObj.orderType = 1;
                paramsObj.refundReason = this.refundReason;
                paramsObj.userId = this.userId;
                this.medorderrefund(this.serialize(paramsObj))
            },
            async medorderrefund(params) {
                let data = await getSources(
                    "/depression-mip/api/medquestion/medorderrefund", params);
                if (data.status == 0) {
                    alert(`退款成功`)
                    this.mask2=false;
                    this.refundReason='';
                    this.id='';
                } else {
                    alert(`${data.msg}`);
                }
            },
            change(n) {
                this.pageIndex = 1;
                this.homePageTopicList = [];
                this.qStatus = n;
                this.getTopicList(this.pageIndex)
            },
            async medorderwriteoff(id) {
                let data = await getSources(
                    "/depression-mip/api/medquestion/medorderwriteoff", `orderId=${id}&orderType=1`);
                if (data.status == 0) {
                    this.mask1=true;
                } else {
                    alert(`${data.msg}`);
                }
            },
            async getTopicList(pageIndex) {
                let obj ={};
                obj.pageIndex=pageIndex;
                obj.pageSize=10;
                obj.doctorId=this.doctorId;
                let data = await getSources("/bear-scale/mip/microArticle/getArticleList.json", obj);
                if (data.status === 0) {
                    this.homePageTopicList = [...this.homePageTopicList, ...data.articleList];
                    this.homePageTopicList.forEach((item) => {   //checkBox
                        Vue.set(item, "remarkStatus", false);
                    })
                    this.count = data.count;
                    this.isLoading = false;
                    if (this.pageIndex >= Math.ceil(this.count / 10)) {
                        this.noMoreData = true
                    } else {
                        this.noMoreData = false
                    }
                }else{
                    alert(data.msg)
                }
            },
//            async getMyTopicList(pageIndex) {
//                let data = await getSources("/topicCenter/topic/getPsychoCommentTopicList", `pageIndex=${pageIndex}&pageSize=10&mid=${this.mid}`);
//                if (data.code === 0) {
//                    this.homePageTopicList = [...this.homePageTopicList, ...data.psychoCommentTopicList];
//                    this.count=data.count;
//                    this.isLoading = false;
//                    if(this.pageIndex>=Math.ceil(this.count/10)){
//                        this.noMoreData=true
//                    }else{
//                        this.noMoreData=false
//                    }
//                }
//            },
            toDetail(id,qid) {
                this.$router.push(`/reply?id=${id}&qid=${qid}`)
            },
            async modifyArticle() {
                let data = await getSourcesJson("/bear-scale/mip/microArticle/modifyArticle.json", JSON.stringify({
                    isDelete:1,
                    articleId:this.articleId
                }));
                if (data.status === 0) {
                    this.homePageTopicList=[];
                    this.getTopicList(1);
                    this.cancle()
                } else {
                    alert(`${data.msg}`);
                }
            },
            handleScroll(){
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / 10)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getTopicList(this.pageIndex)
                    }
                }
            },
            // ...
//            scroll() {
//                if (this.isLoading == true) {
//                    return
//                }
//                window.onscroll = () => {
//                    console.log(111)
//                    // 距离底部200px时加载一次
//                    let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
//                    let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
//                    if (bottomOfWindow && this.isLoading == false) {
//
//                        if (this.pageIndex >= Math.ceil(this.count / 10)) {
//                            this.noMoreData = true
//                        } else {
//                            this.isLoading = true;
//                            this.pageIndex = this.pageIndex + 1;
//                            this.getTopicList(this.pageIndex)
//                        }
//                    }
//                }
//            }
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.userId=localStorage.getItem("userId")
            this.doctorId=localStorage.getItem("doctorId")
//            this.scroll()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
            this.getTopicList(this.pageIndex)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/article.vue